import React from "react";
import { useReportsPageStyles } from "./index.styles";

export default function ReportsPage() {
  const useStyles = useReportsPageStyles();

  return <div className={useStyles.container}>reports</div>;
}
